import "./PoliticalParty.scss";
import ruteload from "../../assets/img/logo-elecciones-colombia.png";

const PoliticalParty = ({ coalition, name, color }) => {
  const votes_percent = coalition?.reduce((total, value) => total + value.votes_percent, 0).toFixed(2) || "00.00";
  const votes = coalition?.reduce((total, value) => total + value.votes, 0) || "00000";

  let rute = `${name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()}` || ruteload;

  return (
    <div className="p-party">
      <div className="p-party__logo">
        <img src={require(`../../assets/img/${rute}.png`)} alt="logo partido" />
      </div>
      <div className="p-party__bar" style={{ backgroundColor: color }}></div>
      <div className="p-party__name" style={{ color: color }}>
        {name}
      </div>
      <div className="p-party__divider"></div>
      <div className="p-party__votes">
        <div className="p-party__votes-percent" style={{ color: color }}>
          <span>{votes_percent}%</span>
        </div>
        <div className="p-party__votes-number">
          <span>VOTOS</span>
          <span>{new Intl.NumberFormat().format(votes)}</span>
        </div>
      </div>
    </div>
  );
};

export default PoliticalParty;
